import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '../core/root-model'

export const MODEL_NAME = 'Office'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    officeCode: types.maybeNull(types.string),
    territorialDirectoryCode: types.maybeNull(types.string),
    territorialDirectoryDesc: types.maybeNull(types.string),
    officeName: types.maybeNull(types.string),
    street: types.maybeNull(types.string),
    region: types.maybeNull(types.string),
    locality: types.maybeNull(types.string),
  })
  .volatile((self) => ({
    get store() {
      return getRoot(self)[`${MODEL_NAME}Store`]
    },
    // _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))

export default Model
